import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../components/UI/Loading";
import { fetchBlog } from "../../features/DetailsBlog/DetailsBlogSlice";
import fetchLikeBlog from "../../features/DetailsBlog/thunk/fetchLikeBlog";
import fetchSaveBlog from "../../features/DetailsBlog/thunk/fetchSavesBlog";

const Blog = ({ blogId }) => {
  const { blog, isLoading, isError, error } = useSelector(
    (state) => state.blog
  );
  const dispatch = useDispatch();
  const { id, title, description, image, tags, likes, isSaved } = blog;
  let tagContent = null;
  tagContent = tags?.length > 0 && tags.map((tag) => `#${tag}`).join(`, `);

  useEffect(() => {
    dispatch(fetchBlog(blogId));
  }, [dispatch, blogId]);

  // decide what to render
  let content = null;
  if (isLoading) content = <Loading />;

  if (!isLoading && isError)
    content = <div className="col-span-12">{error}</div>;

  if (!isLoading && !isError && !blog?.id) {
    content = <div className="col-span-12">No Blog found!</div>;
  }

  const handleLikesButton = (id, likes) => {
    dispatch(fetchLikeBlog({ id, likes })).then((data) => {
      dispatch(fetchBlog(blogId));
    });
  };
  const handleSaveButton = (id, isSaved) => {
    dispatch(
      fetchSaveBlog({
        id,
        isSaved,
      })
    ).then((data) => {
      dispatch(fetchBlog(blogId));
    });
  };
  return (
    <>
      {!isLoading && !isError && blog?.id ? (
        <main className="post">
          <img
            src={image}
            alt={title}
            className="w-full rounded-md"
            id="lws-megaThumb"
          />
          <div>
            <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
              {title}
            </h1>
            <div className="tags" id="lws-singleTags">
              {/* <span>#python,</span> <span>#tech,</span> <span>#git</span> */}
              <span>{tagContent}</span>
            </div>
            <div className="btn-group">
              {/* <!-- handle like on button click --> */}
              <button
                onClick={() => handleLikesButton(id, likes)}
                className="like-btn"
                id="lws-singleLinks"
              >
                <i className="fa-regular fa-thumbs-up"></i> {likes}
              </button>
              {/* <!-- handle save on button click --> */}
              {/* <!-- use ".active" className and "Saved" text  if a post is saved, other wise "Save" --> */}
              <button
                onClick={() => handleSaveButton(id, isSaved)}
                className={`${isSaved && "active"} save-btn`}
                id="lws-singleSavedBtn"
              >
                <i className={`fa-regular fa-bookmark`}></i>{" "}
                {isSaved ? "Saved" : "Save"}
              </button>
            </div>
            <div className="mt-6">
              <p>{description}</p>
            </div>
          </div>
        </main>
      ) : (
        content
      )}
    </>
  );
};

export default Blog;
